//React
//Components
import {
  Accordion,
  AlertBox,
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Radio,
  RupeeAmount,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  GetApplicationDetailsApi,
  registerClientApi,
  setGeneralDetails,
  UpdateApplicationApi,
  useGeneralDetails,
  useGetApplicationDetailsApiDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import {
  ChangeHistory,
  EventManager,
  EventNames,
  dateFormat,
  validateEmail,
} from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import CrossIcon from "assets/icons/cross.svg";
import EditIcon from "assets/icons/edit.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
import VisibleIcon from "assets/Dashboard/icons/visible.png";
import InvisibleIcon from "assets/Dashboard/icons/invisible.png";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();

  //Constants
  const [redirectionUrl, setRedirectionUrl] = useState("");
  const [activeEnvironment, setActiveEnvironment] = useState("");
  const [incomingMsg, setIncomingMsg] = useState("");
  const [outgoingMsg, setOutgoingMsg] = useState("");
  const [domain, setDomain] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [showDomainInput, setShowDomainInput] = useState(false);
  const [showBundleIdInput, setShowBundleIdInput] = useState(false);
  const [urlInputDisabled, setUrlInputDisabled] = useState(true);
  const [
    authorizedEnvironmentsInputDisabled,
    setAuthorizedEnvironmentsInputDisabled,
  ] = useState(true);
  const [inputDisabled, setInputDisabled] = useState(true);
  const [secretKetVisibility, setSecretKetVisibility] = useState(false);
  const [idsDetails, setIdsDetails]: any = useState({});

  //Slices
  const generalDetails = useGeneralDetails();
  const userDetails = useGetUserDetailsApiDetails();
  const applicationDetails = useGetApplicationDetailsApiDetails();

  useEffect(() => {
    if (generalDetails.activeApplicationID) {
      setGeneralDetails({
        activeSideMenuOption: "Application",
      });
      dispatch(
        GetApplicationDetailsApi({
          applicationId: generalDetails.activeApplicationID,
          organizationId: localStorage.getItem("organisationID"),
          callback: setDefaultValues,
        })
      );
    } else {
      ChangeHistory("back", ROUTE_PATH.DASHBOARD.APPLICATION);
    }
    return () => {
      setGeneralDetails({
        activeApplicationID: "",
      });
      localStorage.removeItem("activeEnvironment");
    };
  }, []);

  const clearState = () => {
    setDomain("");
    setBundleId("");
  };

  useEffect(() => {
    clearState();
    if (activeEnvironment === "Test environment") {
      setIdsDetails({ ...applicationDetails?.data?.envs?.UAT });
      setRedirectionUrl(
        applicationDetails?.data?.envs?.UAT?.redirectionUrl ?? ""
      );
      setIncomingMsg(applicationDetails?.data?.envs?.UAT?.messages.incomingMsg);
      setOutgoingMsg(applicationDetails?.data?.envs?.UAT?.messages.outgoingMsg);
    } else {
      setIdsDetails({ ...applicationDetails?.data?.envs?.PROD });
      setRedirectionUrl(
        applicationDetails?.data?.envs?.PROD?.redirectionUrl ?? ""
      );
      setIncomingMsg(
        applicationDetails?.data?.envs?.PROD?.messages.incomingMsg
      );
      setOutgoingMsg(
        applicationDetails?.data?.envs?.PROD?.messages.outgoingMsg
      );
    }
  }, [activeEnvironment]);

  const inputChange = (event: any, setValue: any) => {
    let value = event?.target?.value;
    setValue(value);
  };

  const setDefaultValues = (values: any) => {
    setTimeout(() => {
      setActiveEnvironment(
        localStorage.getItem("activeEnvironment") ?? "Test environment"
      );
    }, 0);
  };

  const updateApplicationDetails = (updatedApplicationDetails?: any) => {
    dispatch(
      UpdateApplicationApi({
        applicationId: generalDetails.activeApplicationID,
        organizationId: localStorage.getItem("organisationID"),
        environment: activeEnvironment === "Test environment" ? "UAT" : "PROD",
        ...updatedApplicationDetails,
        callback: checkIfApplicationUpdated,
      })
    );
  };

  const checkIfApplicationUpdated = (response) => {
    if (response.success) {
      localStorage.setItem("activeEnvironment", activeEnvironment);
      setActiveEnvironment("Prod environment");
      dispatch(
        GetApplicationDetailsApi({
          applicationId: generalDetails.activeApplicationID,
          organizationId: localStorage.getItem("organisationID"),
          callback: setDefaultValues,
        })
      );
      setShowDomainInput(false);
      setShowBundleIdInput(false);
      toast.success("Application updated successfully");
    }
  };

  //Render UI
  const TopSection = (
    <DashboardHeader
      title={
        <FlexBox
          justifyBetween
          className="top-section animated fadeInUp delay-01s"
          alignCenter
        >
          <div>
            <p className="fs-32 font-heavy">
              {applicationDetails?.data?.appName}
            </p>
            <p className="fs-14 clr-disabled">
              {applicationDetails?.data?.platform ?? "Android"}
            </p>
          </div>
          <Image
            src={CrossIcon}
            className="absolute-cross-icon clicking-animation"
            onClick={() => {
              ChangeHistory("push", ROUTE_PATH.DASHBOARD.APPLICATION);
            }}
          />
        </FlexBox>
      }
    />
    // <FlexBox
    //   justifyBetween
    //   className="top-section animated fadeInUp delay-01s w-70"
    //   alignCenter
    // >
    //   <div>
    //     <p className="fs-32 font-heavy">{applicationDetails?.data?.appName}</p>
    //     <p className="fs-14 clr-disabled">
    //       {applicationDetails?.data?.platform ?? "Android"}
    //     </p>
    //   </div>
    //   <Image
    //     src={CrossIcon}
    //     className="cross-icon clicking-animation"
    //     onClick={() => {
    //       ChangeHistory("push", ROUTE_PATH.DASHBOARD.APPLICATION);
    //     }}
    //   />
    // </FlexBox>
  );

  const TopTabSection = (
    <>
      <FlexBox
        alignEnd
        className="top-tabs mr-v-30 animated fadeInUp delay-02s border-bottom"
      >
        <p
          className={cx(
            activeEnvironment === "Test environment" && "active",
            "fs-14 font-medium pd-b-10 curs-point transition"
          )}
          onClick={() => {
            setActiveEnvironment("Test environment");
          }}
        >
          Test environment
        </p>
        <p
          className={cx(
            activeEnvironment === "Live environment" && "active",
            "fs-14 font-medium pd-b-10 curs-point transition"
          )}
          onClick={() => {
            setActiveEnvironment("Live environment");
          }}
        >
          Live environment
        </p>
      </FlexBox>
      {idsDetails?.status === "INACTIVE" && (
        <AlertBox
          message={
            activeEnvironment === "Live environment"
              ? applicationDetails?.data?.platform === "ANDROID" ||
                applicationDetails?.data?.platform === "IOS"
                ? "Redirection URL and Package Name needs to be set to activate the App"
                : "RedirectionURL and domain needs to be set to activate the app"
              : "Redirection URL needs to be set to activate the App"
          }
          status="FAILED"
          className="mr-b-30 w-70 animated fadeInUp delay-03s"
        />
      )}
    </>
  );

  const ApplicationIds = (
    <div className="mr-t-20 application-ids">
      <p className="fs-14 font-medium">Application ID</p>
      <p className="fs-12 mr-t-10">
        An <span className="bg-theme font-light pd-h-5">applicationId</span> is
        created automatically when a project is created and is not updated
      </p>
      <FlexBox
        justifyBetween
        className="fs-10 pd-b-10 clr-disabled border-bottom mr-t-20"
      >
        <p className="w-70">Value</p>
        <p className="w-25">Date Created</p>
      </FlexBox>
      <FlexBox justifyBetween className="fs-12 pd-v-20 border-bottom">
        <div className="w-70">
          <p className="bg-theme font-light pd-h-5 word-break">
            {idsDetails?.appId?.id}
          </p>
        </div>
        <p className="w-25">
          {dateFormat(applicationDetails?.data?.createdAt)}
        </p>
      </FlexBox>
    </div>
  );

  const SecretIds = (
    <div className="mr-t-20">
      <p className="fs-14 font-medium">Secret Key</p>
      <p className="fs-12 mr-t-10">
        A <span className="bg-theme font-light pd-h-5">appSecret</span> is used
        for <span className="underline">API endpoint authentication</span>. If
        you need to rotate a secret, you can create a new one, replace it, and
        delete the old one.
      </p>
      <FlexBox
        justifyBetween
        className="fs-10 pd-b-10 clr-disabled border-bottom mr-t-20"
      >
        <p className="w-70">Value</p>
        <p className="w-25">Date Created</p>
        {/* <p className="w-10"></p> */}
      </FlexBox>
      <FlexBox justifyBetween className="fs-12 pd-v-20 border-bottom">
        <div className="w-70">
          <FlexBox alignCenter>
            <p className="bg-theme font-light pd-h-5 w-90 word-break">
              {secretKetVisibility
                ? idsDetails?.appSecret
                : `XXXXXXXXXXXXXXXXXXXX${idsDetails?.appSecret?.[0]?.slice(
                    -4
                  )}`}
            </p>
            <Image
              onClick={() => {
                setSecretKetVisibility(!secretKetVisibility);
              }}
              src={secretKetVisibility ? VisibleIcon : InvisibleIcon}
              className="mr-l-10 w-3 curs-point"
            />
          </FlexBox>
        </div>
        <p className="w-25">
          {dateFormat(applicationDetails?.data?.createdAt)}
        </p>
        {/* <p className="w-10 clicking-animation underline curs-point">Refresh</p> */}
      </FlexBox>
    </div>
  );

  const ApiKeys = (
    <Card className="w-70 animated fadeInUp delay-03s">
      <p className="fs-16 font-heavy">API Keys</p>
      <p className="fs-14 mr-t-10">
        API Keys are used for authentication in the OTPless API and SDK
      </p>
      {ApplicationIds}
      {SecretIds}
    </Card>
  );

  const AuthorizedEnvironments = (
    <Card className="w-70 mr-t-40 animated fadeInUp delay-04s">
      <FlexBox justifyBetween alignCenter>
        <p className="fs-16 font-heavy">Authorized Environments</p>
        <div
          className="fs-12 curs-point w-10 clicking-animation text-center edit-icon"
          onClick={() => {
            setAuthorizedEnvironmentsInputDisabled(
              !authorizedEnvironmentsInputDisabled
            );
          }}
        >
          {" "}
          {authorizedEnvironmentsInputDisabled ? (
            <Image src={EditIcon} className="w-20" />
          ) : (
            <p
              className="font-heavy"
              onClick={() => {
                updateApplicationDetails(
                  applicationDetails?.data?.platform === "WEB"
                    ? {
                        domain: idsDetails?.domain,
                      }
                    : {
                        bundleId: idsDetails?.bundleId,
                      }
                );
              }}
            >
              Save
            </p>
          )}
        </div>
      </FlexBox>
      {applicationDetails?.data?.platform === "WEB" && (
        <Accordion
          title={"Domains"}
          content={
            <div>
              {idsDetails?.domain?.length > 0 ? (
                <ul className="dots">
                  {idsDetails?.domain?.map((item: any, index: number) => {
                    return (
                      <li
                        className={cx(
                          index !== idsDetails?.domain?.length - 1 && "mr-b-10"
                        )}
                        key={`domain-list-${index}`}
                      >
                        <p className="fs-14 font-medium">{item.value}</p>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="clr-disabled fs-12">No Domains Added</p>
              )}
              {showDomainInput && (
                <FlexBox
                  alignCenter
                  className="w-100 mr-t-20 redirection-url-input authorized-environments"
                >
                  <Input
                    type="text"
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                    placeholder={"Enter Domain"}
                  />
                  <p
                    className="curs-point fs-12 w-15 font-heavy clicking-animation text-center"
                    onClick={() => {
                      updateApplicationDetails({
                        domain: [
                          {
                            value: domain,
                          },
                        ],
                      });
                    }}
                  >
                    Save
                  </p>
                </FlexBox>
              )}
              <Button
                text={"+ Add domains"}
                variant="no-outline no-shadow mr-t-40 pd-0"
                onClick={() => {
                  setShowDomainInput(true);
                }}
              />
            </div>
          }
          className="mr-t-20 no-shadow full-border fs-14"
        />
      )}
      {(applicationDetails?.data?.platform === "IOS" ||
        applicationDetails?.data?.platform === "ANDROID") && (
        <Accordion
          title={
            applicationDetails?.data?.platform === "ANDROID"
              ? "Package Name"
              : "Bundle IDs"
          }
          content={
            <div>
              {idsDetails?.bundleId?.length > 0 ? (
                <ul className="dots">
                  {idsDetails?.bundleId?.map((item: any, index: number) => {
                    return (
                      <li
                        className={cx(
                          index !== idsDetails?.bundleId?.length - 1 &&
                            "mr-b-10"
                        )}
                        key={`bundleId-list-${index}`}
                      >
                        <Input
                          type="text"
                          value={item.value ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            let tempIdDetails: any = { ...idsDetails };
                            let tempBundleIds: any = tempIdDetails.bundleId;
                            let tempUpdatedJson: any = tempBundleIds[index];
                            tempUpdatedJson = {
                              ...tempUpdatedJson,
                              value,
                            };
                            tempBundleIds = [
                              ...tempBundleIds.slice(0, index),
                              tempUpdatedJson,
                              ...tempBundleIds.slice(index + 1),
                            ];
                            tempIdDetails = {
                              ...tempIdDetails,
                              bundleId: [...tempBundleIds],
                            };
                            setIdsDetails({ ...tempIdDetails });
                          }}
                          className=""
                          placeholder={
                            applicationDetails?.data?.platform === "ANDROID"
                              ? "Enter Package Name"
                              : "Enter Bundle ID"
                          }
                          readOnly={authorizedEnvironmentsInputDisabled}
                        />
                        {/* <p className="fs-14 font-medium">{item.value}</p> */}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="clr-disabled fs-12">
                  No{" "}
                  {applicationDetails?.data?.platform === "ANDROID"
                    ? "Package Name"
                    : "Bundle IDs"}{" "}
                  Added
                </p>
              )}
              {showBundleIdInput && (
                <FlexBox
                  alignCenter
                  className="w-100 mr-t-20 redirection-url-input authorized-environments"
                >
                  <Input
                    type="text"
                    value={bundleId}
                    onChange={(e) => setBundleId(e.target.value)}
                    placeholder={
                      applicationDetails?.data?.platform === "ANDROID"
                        ? "Enter Package Name"
                        : "Enter Bundle ID"
                    }
                  />
                  <p
                    className="curs-point fs-12 w-15 font-heavy clicking-animation text-center"
                    onClick={() => {
                      updateApplicationDetails({
                        bundleId: [
                          {
                            value: bundleId,
                          },
                        ],
                      });
                    }}
                  >
                    Save
                  </p>
                </FlexBox>
              )}
              <Button
                text={`+ Add ${
                  applicationDetails?.data?.platform === "ANDROID"
                    ? "Package Name"
                    : "Bundle ID"
                }`}
                variant="no-outline no-shadow mr-t-40 pd-0"
                onClick={() => {
                  setShowBundleIdInput(true);
                }}
              />
            </div>
          }
          className="mr-t-20 no-shadow full-border fs-14"
        />
      )}
    </Card>
  );

  const RedirectUrls = (
    <Card className="w-70 mr-t-40 animated fadeInUp delay-05s">
      <p className="fs-16 font-heavy">Redirect URLs</p>
      <p className="fs-12 mr-t-10">
        Create a route that will act as your link endpoint. Users will be
        redirected there from the WhatsApp Chat. The route should accept a token
        as a query parameter that you will use to authenticate. For example,
        your route should be something like https://example.com/signup. Users
        will be redirected to https://example.com/signup?token=abc, where abc is
        the token that will help SDK to validate the user. If you are
        integrating the button in Android or iOS application then we recommend
        to use custom URI like example://signup?token=abc
      </p>
      <FlexBox
        justifyBetween
        className="fs-10 pd-b-10 clr-disabled border-bottom mr-t-20"
      >
        <p>URLs</p>
      </FlexBox>
      <FlexBox
        justifyBetween
        className="fs-12 pd-v-20 border-bottom redirection-url-input"
      >
        <Input
          type="text"
          value={redirectionUrl}
          onChange={(e) => setRedirectionUrl(e.target.value)}
          className="br-9 w-85"
          placeholder={"Enter Redirection URL"}
          readOnly={urlInputDisabled}
        />
        {/* <p className="w-85">{applicationDetails?.data?.redirectionURL}</p> */}
        <p
          className="curs-point w-10 clicking-animation text-center"
          onClick={() => {
            setUrlInputDisabled(!urlInputDisabled);
          }}
        >
          {" "}
          {urlInputDisabled ? (
            <Image src={EditIcon} className="w-20" />
          ) : (
            <span
              className="font-heavy"
              onClick={() => {
                updateApplicationDetails({
                  redirectionURL: redirectionUrl,
                });
              }}
            >
              Save
            </span>
          )}
        </p>
      </FlexBox>
    </Card>
  );

  const Messages = (
    <Card className="w-70 mr-t-40 messages animated fadeInUp delay-05s">
      <FlexBox justifyBetween alignCenter>
        <p className="fs-16 font-heavy">Messages</p>
        <p
          className="fs-12 curs-point w-10 clicking-animation text-center"
          onClick={() => {
            setInputDisabled(!inputDisabled);
          }}
        >
          {inputDisabled ? (
            <Image src={EditIcon} className="w-20" />
          ) : (
            <span
              className="font-heavy"
              onClick={() => {
                updateApplicationDetails({
                  outgoingMsg: outgoingMsg,
                  incomingMsg: incomingMsg,
                });
              }}
            >
              Save
            </span>
          )}
        </p>
      </FlexBox>
      <p className="fs-12 mr-t-10">
        <TitleBlock
          title={"Enter Outgoing Message"}
          titleClass="clr-theme font-medium"
          content={
            <Input
              type="textarea"
              readOnly={inputDisabled}
              value={outgoingMsg}
              onChange={(event: any) => inputChange(event, setOutgoingMsg)}
              className="fs-14"
            />
          }
        />
        <TitleBlock
          title={"Enter Incoming Message"}
          titleClass="clr-theme font-medium"
          className="mr-t-20"
          content={
            <Input
              type="textarea"
              readOnly={inputDisabled}
              value={incomingMsg}
              onChange={(event: any) => inputChange(event, setIncomingMsg)}
              className="fs-14"
            />
          }
        />
      </p>
    </Card>
  );

  //Return UI
  return (
    <DashboardScreen
      className="application-details-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {TopTabSection}
      {ApiKeys}
      {RedirectUrls}
      {Messages}
      {AuthorizedEnvironments}
    </DashboardScreen>
  );
};

export default Landing;
